import { observer } from 'mobx-react-lite'
import { ComponentProps, FC } from 'react'
import { requiresUserLoggedIn } from '../../../AuthFlow/AuthFlowModal'
import { Modal } from '../../../core/Modal'
import MintSoundModalContent from './MintSoundModalContent'

export const MintSoundModal: FC<ComponentProps<typeof Modal>> = observer(
  ({ trigger, ...props }) => {
    const wrappedTrigger = requiresUserLoggedIn(trigger)

    return (
      <Modal trigger={wrappedTrigger} noPadding {...props}>
        <MintSoundModalContent />
      </Modal>
    )
  }
)
